import React, { useState } from "react";
import {
  Box,
  Button,
  Collapse,
} from "@mui/material";
import "./BlogContent.scss";
import { LOCALIZATION } from "../../utils/localization";
import { useTranslation } from "react-i18next";

const BlogContent: React.FC<any> = (props) => {
   const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  const handleToggle = () => {
    setExpanded(!expanded);
  };

  return (
    <Box>
      <h1>
        Temple Dekho: Book Personalized Pujas and Connect with India’s Most
        Sacred Temples
      </h1>
      <Collapse in={expanded} collapsedSize={100}>
        <p>
          In today’s fast-paced world, where daily responsibilities often
          overshadow our spiritual needs, Temple Dekho is here to transform your
          spiritual journey. We are your trusted partner in experiencing divine
          moments through seamless{" "}
          <span className="boldedText">online puja booking services</span>{" "}
          across various temples in India.
        </p>

        <p>
          In today's age, Indians are settled worldwide, but they all try hard
          to fulfill their religious aspirations. They need spiritual options
          and information about religious methods and processes. The consequence
          is that most of our new generation has lost touch with spirituality
          and divine grace. They are slowly drifting from their roots, an
          indispensable part of our identity.
        </p>

        <p>
          At Temple Dekho, we not only provide easy methods to{" "}
          <span className="boldedText">book online pujas</span> at various
          temples, but we also aim to educate everyone about the significance of
          the Indian cultural system. Our venture is dedicated to helping build
          faith and encouraging our younger generations to connect deeply with
          spirituality, as it is the only way to attain moksha.
        </p>

        <h2>Our Mission: Making Spirituality Accessible</h2>

        <p>
          At Temple Dekho, we understand that everyone has specific barriers
          that prevent them from participating in spiritual activities. The
          barriers can be busy schedules, health issues, geographical distance,
          and many other reasons people find visiting temples challenging. Our
          mission at Temple Dekho is clear: we want to make spirituality
          accessible to everyone by offering them a platform where people can
          book <span className="boldedText">online puja services</span>{" "}
          effortlessly.
        </p>

        <p>
          Temple Dekho integrates technology with tradition to enhance spiritual
          journeys, providing secure and innovative solutions for convenient
          access to sacred rituals.
        </p>

        <p>
          We aim to preserve and promote ancient rituals while adapting to
          modern lifestyles. Using technology, we ensure that the divine
          blessings from{" "}
          <a href="/temples" className="linkedText">
            famous temples in India
          </a>{" "}
          reach everyone, no matter the circumstances. Temple Dekho is more than
          a service; it is our commitment to foster spirituality in the modern
          world.
        </p>

        <h2>Why is Spirituality Important?</h2>

        <p>
          Spirituality helps people overcome trauma and hardships in Life. A
          solid spiritual outlook enables you to find meaning in difficult
          circumstances. People who are dedicated to spirituality can move on
          from their traumatic experiences.
        </p>

        <p>
          The spiritual practice of recognizing the interconnectedness of all
          Life can also help buffer the pain that comes with difficult
          experiences. If we compassionately remind ourselves that failure is
          part of the human experience, our hardships become easier to tackle.
        </p>

        <h3>Spiritual People Make Healthy Choices</h3>

        <p>
          Spiritual people often make healthier choices, as their beliefs
          promote self-awareness and mindfulness. They tend to avoid harmful
          behaviors like crime and violence, focusing instead on practices that
          nurture the mind, body, and soul. By aligning their actions with
          spiritual values, they prioritize well-being and inner peace.
        </p>

        <h3>Spirituality Helps You Live Longer</h3>

        <p>
          People with spiritual, solid lives are said to live long. Spiritual
          practices are positively associated with better health outcomes.
        </p>

        <h2>What Temple Dekho Offers:</h2>

        <p>
          At Temple Dekho, we bring the Divine closer to you by providing a
          comprehensive platform for all your spiritual needs. Whether you want
          to connect to your roots, perform pujas, or explore the varied{" "}
          <a href="/temples" className="linkedText">temples in India</a>, we have you
          covered. Our mission is to facilitate each individual's spiritual
          journey so everyone has meaning in their Life. Our services include:
        </p>

        <h3>Discover Temples Across India</h3>

        <p>
          Indians have a rich heritage. Numerous{" "}
          <span className="boldedText">Hindu temples in India</span> have unique
          histories, rich architecture, and significance. At Temple Dekho, we
          try our best to make exploring these places easy for you. With our
          user-friendly interface, you can discover different temples across
          India and learn about their history, puja timings, etc. Explore
          renowned temples in India with Temple Dekho, like Ram Mandir, Shri
          Kashi Vishwanath Temple, Jagannath Temple, and Kedarnath Tirtha. With
          each listing, you get the:
        </p>
        <ul>
          <li>Temple Timings</li>
          <li>Rituals</li>
          <li>Festivals</li>
          <li>All information required for your visit.</li>
        </ul>

        <h2>Book Personalized Puja and Rituals with <a href="/" className="linkedText">Temple Dekho</a></h2>

        <p>
          We understand the importance of rituals in Hindu culture. You can book
          personalized <a href="/pujas" className="linkedText">Hindu puja online</a> and
          rituals tailored to your needs with us. Our Puja Categories include:
        </p>

        <h5 style={{ fontWeight: "600" }}>Relief Puja</h5>
        <p>
          Are you facing legal disputes, debts, or ancestral curses? Book a
          relief puja at a world-
          <span className="boldedText">famous temple in India {" "}</span>
          that will help you cleanse the negative energies from your Life.
          Relief puja is conducted by experienced priests across the temples of
          India and is specifically designed to embrace spiritual relief.
        </p>

        <h5 style={{ fontWeight: "600" }}>Protection Puja</h5>
        <p>
          <span className="boldedText">A protection puja</span> is a sacred
          ritual designed to ward off negative energies like black magic from
          life. By invoking powerful deities and reciting protective mantras,
          this puja will help you create a spiritual shield around you. All you
          have to do is select an available date, and we will arrange an
          experienced priest who specializes in performing protection puja. You
          can participate in it from the comfort of your home.
        </p>

        <h5 style={{ fontWeight: "600" }}>Marriage</h5>
        <p>
          Are you facing problems in your marriage? If you want marital bliss,
          then book this puja to bring love back into your married Life. This
          puja will help you foster communication, promote understanding, and
          attract positive energies, helping you overcome all the challenges in
          your marriage.
        </p>

        <h5 style={{ fontWeight: "600" }}>Dosh Nivaran Puja</h5>
        <p>
          Are you facing challenges and obstacles in your life? Dosh Nivaran
          Puja is designed to remove astrological doshas that might be hindering
          your progress. With us, you can book:
        </p>
        <ul>
          <li>Kaal Sarp Dosh Puja</li>
          <li>Rahu Dosh</li>
          <li>Shani Dosh</li>
          <li>Manglik Dosh</li>
          <li>Shrapit Dosh</li>
          <li>Navagraha Dosh</li>
          <li>Sade Sati Dosh</li>
          <li>Chandal dosh</li>
        </ul>

        <h5 style={{ fontWeight: "600" }}>Wealth</h5>
        <p>
          Do you want financial abundance and stability in your Life? The wealth{" "}
          <span className="boldedText">Hindu puja online</span> aims to remove
          all obstacles and provide economic prosperity. Book wealth puja with
          Temple Dekho today!!
        </p>

        <h5 style={{ fontWeight: "600" }}>Spiritual Growth</h5>
        <p>
          If you want to journey to a deeper self,{" "}
          <span className="boldedText">spiritual growth puja</span> will help
          you foster inner peace. Performed by skilled priests across{" "}
          <strong>temples in India</strong>, this puja can help you gain clarity
          on the purpose of Life, promote inner peace, and strengthen your
          connection with God.
        </p>

        <h5 style={{ fontWeight: "600" }}>Health</h5>
        <p>
          Are you seeking blessings from God for your well-being or fertility?
          Well-being and{" "}
          <span className="boldedText">
            fertility pujas at Hindu temples in India
          </span>{" "}
          promote good health, enhance overall well-being, and help you conceive
          with ease. Book your Health, Wellbeing, and Fertility Blessings Puja
          today through Temple Dekho and embrace the journey toward holistic
          wellness and abundance!
        </p>

        <h2>Book E-Puja and Other Related Services</h2>

        <p>
          You can now experience the power of devotion from the comfort of your
          home. You can book E pujas with Temple Dekho. Our platform will
          connect you to various temples across India and help you perform{" "}
          <span className="boldedText">sacred rituals online</span>. Each ritual
          is conducted by an experienced priest who ensures the authenticity and
          reverence of each puja that you perform with us. All you have to do is
          visit our app/website, choose your desired puja, complete the booking
          with an easy payment option, and invite the blessings of the divine to
          your Life today.
        </p>

        <h4>Live Darshans</h4>
        <p>
          It's time to immerse yourself in the Divine and experience of{" "}
          <a href="/livedarshan" className="linkedText">Online Darshans</a> with Temple Dekho.
          You can now connect with any temple across India from anywhere in the
          world and participate in the rituals in real-time. Join us for Live{" "}
          Darshans and deepen your connection with God.
        </p>

        <h4>Know Your Rashifal</h4>
        <p>
          With Temple Dekho, you can now unlock the mysteries of your destiny
          with our “Know Your Rashifal” feature. Rashifal or zodiac signs help
          you understand how celestial movements affect your Life.
        </p>

        <h4>Chadawa</h4>
        <p>
          <a href="/chadhavaTemples" className="linkedText">
            Chadawa
          </a>{" "}
          is a ritual in which devotees offer donations or contributions to
          temples and priests as a part of a vow or in gratitude for blessings.
          It is a way to seek divine favour or express gratitude for the
          well-being of self and family. You can now get these services at
          Temple Dekho along with <a href="/chadhavaTemples" className="linkedText">online prasadam delivery</a>. To know more, please contact us today.
        </p>

        <h4>Pind Daan</h4>
        <p>
          Pind Daan is a ritual in which Hindus offer food to deceased
          ancestors. It is a way to honour the ancestors and seek their
          blessings. Pind Daan helps the ancestors rest in peace and attain
          moksha. This service is available at Temple Dekho. Contact us to know
          more.
        </p>
        <h2>Book Your Rituals Today at Temple Dekho</h2>
        <p>
          Simplify your spiritual journey by booking <strong>Chadawa</strong> or{" "}
          <a href="#" className="linkedText">
            Pind Daan
          </a>{" "}
          online with Temple Dekho. Easily ensure blessings for your family or
          honor your ancestors. Visit our website or app now and secure your
          puja service with just a few clicks!
        </p>

        <h4>Features of Online Puja</h4>
        <ul>
          <li>
            <strong>Online pujas</strong> at Temple Dekho are performed as per
            authentic traditions.
          </li>
          <li>
            Fully personalized{" "}
            <span className="boldedText">best online pujas</span> only for you
            and your family.
          </li>
          <li>
            Sponsor online pujas on behalf of a parent or a family member.
          </li>
          <li>
            Full-fledged, complete online pujas with no length restrictions.
          </li>
          <li>The highest quality puja samagri used during all our pujas.</li>
          <li>Puja prasad will be couriered to you.</li>
        </ul>
        <p>
          A trusted priest from an individual temple who is in partnership with
          Temple Dekho will perform the puja for you strictly according to
          ‘vidhi’ with the chanting of Sanskrit ‘shlokas’ to bless you and your
          family members.{" "}
          <span className="boldedText">Online Temple Pujas</span> are an area
          that Temple Dekho takes pride in being able to deliver. All you need
          to do is find a temple and book your Puja. We will undertake the puja
          as per your wish on the dates available.
        </p>

        <h2>Benefits of Booking Online Puja with Temple Dekho</h2>

        <h3>Convenience and Efficiency</h3>
        <p>
          Another vital aspect of booking puja at{" "}
          <a href="/temples" className="linkedText">
            India's famous Hindu temples
          </a>{" "}
          is convenience. You do not have to spend considerable time moving
          around or waiting in line to perform your worship. With just a few
          simple mouse clicks, booking a puja with the temple you like is now
          possible.
        </p>

        <h3>Accessibility for All</h3>
        <p>
          Another benefit of{" "}
          <span className="boldedText">online puja services in India</span> is
          that even physically disabled people can now perform pujas from the
          comfort of their homes. People who live far from India can now perform
          pujas and seek the blessings of the Divine with Temple Dekho.
        </p>

        <h3>Transparency and Trustworthiness</h3>
        <p>
          Temple Dekho is a highly reliable{" "}
          <span className="boldedText">online puja website</span>. We strive to
          be completely genuine and trustworthy. On our website, you can find a
          comprehensive description of temples and puja practices that will
          leave room for no doubts. We also have secure payment options,
          ensuring that your religious rituals are of the highest conduct and
          standards.
        </p>

        <h3>Spiritual Growth and Connection</h3>
        <p>
          Through online pujas, you take one step further to deepen your
          spiritual connection with God. Temple Dekho's features of convenience,
          accessibility, and choices will enhance the quality of the religious
          experience.
        </p>

        <h3>The Future of Online Puja Services in India</h3>
        <p>
          Earlier, performing puja involved going to the temple, arranging a
          priest, and performing many chores to complete the rituals. But now,
          since technology has advanced, people can order puja online, making
          things easy and fast.
          <span className="boldedText">Online puja services in India</span>{" "}
          fulfill the purpose of health, prosperity, or peace by offering puja
          services by well-known priests in the famous temples of the country.
        </p>
        <p>
          Such convenience is highly appreciated as it provides an excellent
          opportunity for those who are unable to visit the temple due to great
          distances, work commitments, or health conditions.
        </p>

        <h3>Inclusivity</h3>
        <p>
          One significant shift that has now come into practice with the rise of{" "}
          <span className="boldedText">online puja services</span> is the factor
          of access. Whether you live in a village or a city, there is no need
          to cut your spiritual connection now. Online puja service platforms
          like Temple Dekho enable devotees to conduct rituals on behalf of
          family members at <span className="boldedText">Indian mandirs</span>
          regardless of generational and geographical differences.
        </p>
        <strong>It is time to embrace technology for spiritual growth.</strong>
        <p>
          With the incorporation of technology, some serious questions have
          arisen about the authenticity of{" "}
          <span className="boldedText">online pujas</span>. But with online puja
          booking services like Temple Dekho, you can now be sure that each
          ritual is performed by experienced priests in the well-known temples
          of India.
        </p>
        <p>
          Of course, those people who appreciate tradition but have physical
          constraints can turn to{" "}
          <span className="boldedText">online pooja booking</span>. This makes
          it easier for them to continue with their religious beliefs and cope
          with the challenges of present-day society.
        </p>

        <h5>Book Any of the Following Pujas for Your Requirements</h5>

        <h5>Rudrabhishek at Pashupatinath Mandir, Guwahati</h5>
        <p>
          <a
            href="/templePujaInfo?templeNameKey=Shri-Kashi-Vishwanath-Temple&pujaNameKey=Rudrabhishek"
            className="linkedText"
          >
            Rudrabhishek
          </a>{" "}
          at{" "}
          <a
            href="/templeInfo?templeNameKey=Pashupatinath-Mandir-Guwahati"
            className="linkedText"
          >
            Pashupatinath
          </a>{" "}
          is a significant Vedic ritual performed to obtain Lord Shiva's
          blessings. The puja includes bathing Lord Shiva and chanting mantras
          with Panchamrit and other sacred items. The puja protects devotees
          from negativity and helps bring happiness and success to their Lives.
        </p>
        <p>
          Book your{" "}
          <span className="boldedText">
            Rudrabhishek Puja at Pashupatinath Mandir
          </span>
          , Guwahati, today.
        </p>

        <h5>Maha Mrityunjaya Jaap at Mahakaleshwar Jyotirlinga</h5>
        <p>
          <a
            href="/templePujaInfo?templeNameKey=Mahakaleshwar-Jyotirlinga&pujaNameKey=Maha-Mrityunjaya-Jaap-125-lakh"
            className="linkedText"
          >
            Maha Mrintunjaya Jaap
          </a>{" "}
          is the most potent Homam or yagna for attaining freedom from death,
          diseases, fears, legal cases, and other problems. It is believed that
          Lord Mrityunjaya or Lord Shiva overpowers death. Upon worshipping him,
          one can overcome the miseries of the inner soul caused by this
          materialistic world. Our experienced priests will conduct it from{" "}
          <a
            href="/templeInfo?templeNameKey=Mahakaleshwar-Jyotirlinga"
            className="linkedText"
          >
            Mahakaleshwar Jyotirlinga
          </a>
          , a <span className="boldedText">world-famous temple in India</span>.
          The <strong>Mahakaleshwar temple</strong> is specifically known for
          its association with overcoming death and transcending worldly fears.
          Mahakaleshwar Jyotirlinga is known for its immense spiritual energy.
          By chanting Mahamrityunjaya Jaap here, you can conquer both spiritual
          and physical problems.
        </p>
        <p>Book your puja here with Temple Dekho today!</p>

        <h5>Nam-Gotra Sankalp at Kalighat Temple</h5>
        <p>
          <a
            href="/templePujaInfo?templeNameKey=Kalighat-Temple&pujaNameKey=NamGotra-Sankalp"
            className="linkedText"
          >
            Nam Gotra Sankalp
          </a>{" "}
          is an important ritual performed at{" "}
          <a
            href="/templeInfo?templeNameKey=Kalighat-Temple"
            className="linkedText"
          >
            Kalighat Temple
          </a>
          , dedicated to Goddess Kali in Kolkata. This Sankalp is one to seek
          blessings for health, prosperity, and well-being, especially for
          individuals wishing to perform puja related to their Gotra and Nam. In
          Hinduism, Gotra is related to your family tree. In Nam Gotra Sankalp,
          you vow or pledge that you will connect your spiritual journey to your
          family tree and seek blessings from your ancestors and God. It is also
          said that if you perform this Sankalp at Kalighat temple, you can
          purify karma and bring loads of blessings to your family.
        </p>
        <p>Book this puja with us now!</p>

        <h5>Navgraha Dosh Nivaran Puja at Mangalnath Temple, Ujjain</h5>
        <p>
          <a
            href="/templePujaInfo?templeNameKey=Mangalnath-Temple-Ujjain&pujaNameKey=Mangalik-Dosh-Nivaran-Puja"
            className="linkedText"
          >
            Navgraha Dosh Nivaran Puja
          </a>{" "}
          is a highly revered ritual to neutralize the malefic effects of nine
          planets on one’s astrology charts. The{" "}
          <a
            href="/templeInfo?templeNameKey=Mangalnath-Temple-Ujjain"
            className="linkedText"
          >
            Mangalnath temple
          </a>{" "}
          in Ujjain is the best place for this puja because it is associated
          with the planet Mars, which has a starting influence on our lives.
          Ujjain, the city of temples, is a prominent city that performs all the
          Vedic and astrological pujas. The nine planets play a significant role
          in deciding our destiny. When these planets are not appropriately
          positioned in our charts, you can face a lot of problems in your Life.
          The Dosh Nivaran Puja is specifically designed to align these plants
          and bring peace and prosperity to your Life.{" "}
        </p>

        <h2>How to Book E-Puja Service with Temple Dekho</h2>
        <ol>
          <li>Register on our website/App.</li>
          <li>Log in to the website/App.</li>
          <li>Select Temple.</li>
          <li>Select Puja.</li>
          <li>Book date.</li>
          <li>Enter name and Gotra.</li>
          <li>Make payment.</li>
          <li>Complete the form with devotee details.</li>
          <li>Receive puja video and prasad delivery.</li>
        </ol>

        <h5>Preparing For Online Puja</h5>
        <p>
          The primary purpose of any puja is to purify, heal, and realize a
          higher superior version of yourself; one must prepare for this pious
          ritual in ways to purify the mind, body, soul, and space. Our priests
          will prepare for the worshiper's instructions to prepare for{" "}
          <span className="boldedText">online puja</span> as required in the
          ritual, like fasting (refraining from eating) for a day to detoxify
          the system. Always keep the puja space clean & clutter-free. It would
          be beneficial to wake up early in the Brahma muhurta (early morning)
          on the day of your online puja and start your day with a (Surya
          Arghya) praying to the Sun. One must take a shower on the day of puja
          and wear fresh, clean clothes to feel the divinity.
        </p>

        <p>
          Puja is not only a religious practice; it is also a way to find peace
          in Life. It is an emotion and devotion to your deities. Temple Dekho
          is an <span className="boldedText">online puja service</span>{" "}
          throughout India, where you can find many pujas that you can perform
          across various temples of India.
        </p>

        <p>
          You can book it with us at reasonable prices with a genuine pandit.
          You can do puja sitting at home. After puja, a video and prasad will
          be sent to you.
        </p>

        <p>
          <span className="boldedText">
            Empower your spirituality with an online puja booking service now!!
          </span>
        </p>
      </Collapse>
      <Button
        variant="outlined"
        sx={{ mt: "10px" }}
        onClick={handleToggle}
        color="primary"
      >
        {expanded ? "Read Less" :  t(LOCALIZATION.Read_More)}
      </Button>
    </Box>
  );
};

export default BlogContent;
